import { Company } from './company.type';

export type Environment = 'development' | 'stage' | 'production';

export enum ENVIRONMENT_TYPES {
  development = 'development',
  stage = 'stage',
  production = 'production',
}

export interface CompanyEnvironment {
  PUBLIC_PATH?: string;
  DIST_PATH?: string;
  I18N_PATH?: string;
  COMPANY?: Company;
}

export interface ApiEnvironment {
  API_BASE_PATH?: string;
}

export interface DepositsEnvironment {
  FLYWIRE_DEPOSITS_RETURN_URL?: string;
}

export interface CoreEnvironment extends CompanyEnvironment, DepositsEnvironment {
  production: boolean;
  environment: Environment;
  LOCALE: string;
  PATH_PREFIX?: string;
  RTL_ENABLED: boolean;
}

export type Configuration = Record<string, string | boolean>;

export type EnvironmentAndConfiguration = RuntimeEnvironment & Configuration;
export type RuntimeEnvironment = CoreEnvironment & ApiEnvironment;
